const CONSTANTS = require('frontend-controller/lib/constants')

module.exports = {
	config: {
		navCode: 'main', // which navCode should be rendered

		collapsable: true, // renders an additional nav element to toggle the collapse state
		collapsedByDefault: false, // should the nav be collapsed by default
		horizontal: false, // should the nav be rendered horizontal
		showInlineSubNavElements: true, // if set to true all entities with level > 0 will be rendered inline
		showChildrenIndicator: true, // should an indicator be displayed if children are available
		selectFirstSubEntryOnInit: true, // if set to true the first sub entry (level > 0) will be triggered on attach
	},

	model: {
		activeKey: null, // last selected active nav entry
		activeKeys: {}, // all selected active nav entries (including parents)
		visibleKeys: {}, // all visible keys (including children of active elements)
		collapsed: false, // is the navigation actually collapsed or not
		ignoreHandlers: false, // handlers are used to react to external changes which should be ignored during internal navigation. do not set this unless you know what you are doing.

		actionBossComponent: null, // since multiple nav components should be able to re-perform the very same actions there has to be one boss to perform these actions.
	},

	events: {
		use: {
			type: 'click',
			action(event){
				const self = event.data.component
				const $target = $(event.target).closest('li')
				if($target.length > 0){
					const {
						key = 0
					} = $target.data()

					if($target.hasClass('collapseToggle')) {
						self.collapseToggle()
					} else {
						self.navToEntity(key)
					}
				}
			}
		},
	},

	methods: {



		/////////////////////
		/// MAIN
		/////////////////////

		sanitizeResources(storage){
			for(const entity of this.resourceData.data || []){
				// NOTE: 	resourceData.data and resourceData.entitiesByKey are references to another on the server, but not on the client.
				// 			furthermore, some cache operations may get rid of these references on the server as well.
				// 			this has to be reestablished, so our changes are available in both lists.
				this.resourceData.entitiesByKey[entity.key] = entity
				entity.turnedOn = true

				const entityAttributes = entity.attributes || {}
				const navConfig = (entityAttributes.config || {}).nav || {}
				let title = ''
				let titleKey = ''
				let {
					icon = null,
					forceCollapsedTitle = false,
					isUserProfile = false,
					isLanguageSelector = false,
					showSubNavSymbols = false,
					autoSelectPriority = 0,
				} = navConfig
				showSubNavSymbols |= isLanguageSelector

				if(isUserProfile){
					const {
						firstName,
						lastName,
						code,
						email,
					} = (storage.session || {}).user || {}

					const nameParts = []
					if(firstName || lastName){
						if(firstName){
							nameParts.push(firstName)
						}
						if(lastName){
							nameParts.push(lastName)
						}
					} else if(code){
						nameParts.push(code)
					} else if(email){
						nameParts.push(email)
					}

					if(nameParts.length > 0){
						title = nameParts.join(' ')
					}
				} else if (isLanguageSelector){
					const [language, country] = String(storage.langCode || '').split('-') || []
					icon = `flag-icon flag-icon-${country}`
					titleKey = 'language.language'
				}

				if(!title && entityAttributes.language){
					titleKey = `language.${entityAttributes.language}`
					const titleParts = [storage.__(titleKey)]

					if(entityAttributes.langCode !== storage.langCode){
						const originalTitle = translationManager.getTranslator(entityAttributes.langCode)(titleKey)
						if(titleParts[0] !== originalTitle){
							titleParts.push(originalTitle)
						}
					}
					title = titleParts.join(' - ')
				}
				if(!title && entityAttributes.path){
					titleKey = `nav.byPath.${entityAttributes.path}`
				}

				if(titleKey && !title){
					title = storage.__(titleKey)
				}
				entity.navConfig = {
					title,
					titleKey,
					icon,
					forceCollapsedTitle,
					isUserProfile,
					isLanguageSelector,
					showSubNavSymbols,
					autoSelectPriority,
				}
			}

			this.sanitizeNinjaModuleVisibility(storage)
		},

		/**
		 * handle gui classes and states as if the given entityKey is active.
		 *
		 * @param entityKey				string - entity key to activate
		 */
		guiActivate(entityKey){
			const entitiesByKey = this.resourceData.entitiesByKey || {}
			const entity = entitiesByKey[entityKey || '~MISSING~ENTITY~KEY~']
			if(!entity){
				return
			}

			this.$.find('li.active').removeClass('active')
			this.$.find('li.visible').removeClass('visible')

			const entityAvailable = (entity.navs || {})[this.config.navCode] || false
			if(!entityAvailable){
				return
			}

			const meta = (entity.meta || {})[this.config.navCode] || {}
			const parentMeta = ((entitiesByKey[meta.parentKey] || {}).meta || {})[this.config.navCode] || {}
			parentMeta.lastActiveChildKey = entityKey

			const parentKeys = meta.parentKeys || []
			const activeKeys = [entityKey].concat(parentKeys)
			let visibleKeys = [entityKey].concat(parentKeys).concat(meta.childKeys || [])
			for(const key of parentKeys.reverse()){
				const entity = entitiesByKey[key]
				if(entity){
					const meta = (entity.meta || {})[this.config.navCode] || {}
					const parentMeta = ((entitiesByKey[meta.parentKey] || {}).meta || {})[this.config.navCode] || {}
					visibleKeys = visibleKeys.concat(meta.childKeys)
					parentMeta.lastActiveChildKey = entity.key
				}
			}

			this.model.activeKeys = Object.fromEntries(activeKeys.map(key => [key, true]))
			this.model.visibleKeys = Object.fromEntries(visibleKeys.map(key => [key, true]))

			this.$.find(
				activeKeys
					.map(key => `li[data-key="${key}"]`)
					.join(',')
			).addClass('active')
			this.$.find(
				visibleKeys
					.map(key => `li[data-key="${key}"]`)
					.join(',')
			).addClass('visible')
		},

		/**
		 * handle gui classes and states as if the given entityKey is inactive.
		 *
		 * @param entityKey				string - entity key to deactivate
		 */
		guiDeactivate(entityKey){
			const entitiesByKey = this.resourceData.entitiesByKey || {}
			const entity = entitiesByKey[entityKey || '~MISSING~ENTITY~KEY~']
			if(!entity){
				return
			}

			// const entityAvailable = (entity.navs || {})[this.config.navCode] || false
			// if(!entityAvailable){
			// 	return
			// }

			const meta = (entity.meta || {})[this.config.navCode] || {}
			const childKeys = meta.childKeys || []
			const parentMeta = ((entitiesByKey[meta.parentKey] || {}).meta || {})[this.config.navCode] || {}

			parentMeta.lastActiveChildKey = false
			delete this.model.activeKeys[entityKey]
			for(const key of childKeys){
				delete this.model.visibleKeys[key]
			}

			this.$.find(`li[data-key="${entityKey}"]`).removeClass('active')
			this.$.find(
				childKeys
					.map(key => `li[data-key="${key}"]`)
					.join(',')
			).removeClass('visible')
		},

		/**
		 * trigger all necessary actions to activate the given entityKey.
		 *
		 * @param entityKey             string - entity key to activate
		 * @param isInitialCall			boolean - true if called from outside.
		 * 								NOTE: INTERNAL USE ONLY! NEVER SET FROM OUTSIDE!
		 * @returns {Promise<void>}
		 */
		async navToEntity(entityKey, isInitialCall = true){
			const entitiesByKey = this.resourceData.entitiesByKey || {}
			const entity = entitiesByKey[entityKey || '~MISSING~ENTITY~KEY~'] || {}
			const entityAttributes = entity.attributes || {}
			const meta = (entity.meta || {})[this.config.navCode] || {}
			const action = (entityAttributes.actions || {}).nav
			const navConfig = (entityAttributes.config || {}).nav || {}
			const isLanguageSelector = navConfig.isLanguageSelector
			const isModalAction = ((action || {}).target || {}).position == CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.MODAL
			const actionBossComponent = getComponent('navController', true) || this
			const guiActivationGranted = !isModalAction && entity.type !== 'language'
			const navToParentEntitesGranted = !isModalAction && entity.type !== 'language'

			// change language if necessary
			if(entity.type === 'language'){
				const nextLangCode = entityAttributes.langCode
				if(nextLangCode !== storage.langCode){
					store.set({
						session: {
							data: {
								langCode: nextLangCode,
							},
						},
					})
				}

				return
			}

			// redirect if necessary
			if(isInitialCall && !isLanguageSelector && meta.childKeys.length > 0 && meta.lastActiveChildKey !== false){
				return this.navToEntity(meta.lastActiveChildKey || meta.childKeys[0])
			}



			try {
				// reset gui entry states if necessary
				if(isInitialCall){
					// TODO: POIAAA: fix nav hopping on e.g., language changes
					// TODO: POIAAA: ignoreHandlers should apply to all navs not only to this one?!?
					this.model.ignoreHandlers = true

					if(guiActivationGranted){
						this.guiActivate(entityKey)
					}
				}

				// perform parents actions if necessary
				if(navToParentEntitesGranted){
					for(const parentEntityKey of meta.parentKeys){
						await this.navToEntity(parentEntityKey, false)
					}
				}

				// prevent unnecessary action performs
				const actionKey = `navToEntity_${entityKey}`
				let performActionGranted = false
				if(!actionBossComponent.actions[actionKey]){
					performActionGranted = true
				} else {
					const tabStripNavEntityKeys = this.getActiveTabStripKeys()

					if(
						!tabStripNavEntityKeys.tabStripKey ||
						tabStripNavEntityKeys.tabStripKey !== entityKey ||
						entity.level > 0
					){
						performActionGranted = true
					}
				}

				// perform action if necessary
				if(performActionGranted){
					if(isInitialCall && guiActivationGranted){
						this.model.activeKey = entityKey
					}

					if(action){
						const {
							title,
							titleKey,
							icon,
						} = entity.navConfig || {}

						await actionBossComponent.performAndStoreAction(
							actionKey,
							actionBossComponent.prepareAction(action, undefined, {
								nav: {
									entityKey,
								},
								tab: {
									title,
									titleKey,
									icon,
								},
							}),
							false,
							true
						)
					}
				}

				if(isInitialCall){
					this.model.ignoreHandlers = false
				}
			} catch (error){
				this.model.ignoreHandlers = false
				this.model.lastErrorEntityKey = entityKey
				throw error
			}
		},

		/**
		 * collapse or expand the actual nav according to the actual state.
		 *
		 * @param newCollapsedState		boolean - force state to be collapsed or not
		 */
		collapseToggle(newCollapsedState){
			if(!this.config.collapsable){
				return
			}

			if(newCollapsedState === undefined){
				newCollapsedState = !this.model.collapsed
			}
			this.model.collapsed = newCollapsedState

			if(this.model.collapsed){
				this.$.addClass('collapsed')
			} else {
				this.$.removeClass('collapsed')
			}
		},



		/////////////////////
		/// MISCELLANEOUS
		/////////////////////

		onBuild(storage){
			this.model.collapsed = !!this.config.collapsedByDefault
		},



		/////////////////////
		/// HELPERS
		/////////////////////

		/**
		 * identifies the active entityKeys for the actual tabStrip and its active tab.
		 *
		 * @returns {{tabStripKey: null || string, tabKey: null || string, tabFound: boolean}}
		 */
		getActiveTabStripKeys(){
			const result = {
				activeTabStrip: null,
				tabStripKey: null,
				tabFound: false,
				tabKey: null,
			}
			result.activeTabStrip = getComponent($('body > .appContainer > .content > .main .base_tabStrip_tabStrip.nav'), true)
			if(result.activeTabStrip){
				result.tabStripKey = (result.activeTabStrip.getResourceRegisterContent('nav') || {}).entityKey || null
				const activeTab = result.activeTabStrip.getActiveTabComponent()

				if(activeTab){
					result.tabFound = true
					result.tabKey = (activeTab.getResourceRegisterContent('nav', false) || {}).entityKey || null
				}
			}

			return result
		},

		/**
		 * simple traversal generator
		 *
		 * @returns {Generator<*, void, *>}
		 */
		*each(){
			for(const entity of this.resourceData.data || []){
				yield entity
			}
		},

		// sanitize ninjaModule visibility on clients to account for containerInfo changes
		sanitizeNinjaModuleVisibility(storage){
			const ninjaModules = (((((storage || {}).app || {}).webService || {}).containerInfo || {}).config || {}).ninjaModules || {}

			for(const entity of this.resourceData.data || []){
				const entityAttributes = entity.attributes || {}
				const navConfig = (entityAttributes.config || {}).nav || {}
				const ninjaModule = navConfig.ninjaModule || ''

				entity.turnedOn = (!ninjaModule || (ninjaModules[ninjaModule] || {}).turnedOn === true)
			}
		},
	},

	hooks: {
		async postAttach($element, options){
			if(options.preventDefaultNav){
				return
			}

			let activateEntityKey = this.model.activeKey
			if(!activateEntityKey && this.config.selectFirstSubEntryOnInit){
				const entityKeysByPriority = {}
				let maxPriority = 0
				let defaultKey
				for(const entity of this.resourceData.data || []){
					if(entity.key && entity.level < 1 && entity.navConfig.autoSelectPriority !== undefined && !entityKeysByPriority[entity.navConfig.autoSelectPriority]){
						entityKeysByPriority[entity.navConfig.autoSelectPriority] = entity.key
						maxPriority = Math.max(maxPriority, entity.navConfig.autoSelectPriority)
					}

					if(entity.key && entity.level > 0 && !defaultKey){
						defaultKey = entity.key
					}
				}

				if(maxPriority && entityKeysByPriority[maxPriority]){
					const mainEntity = this.resourceData.entitiesByKey[entityKeysByPriority[maxPriority]] || {}
					if((((mainEntity.meta || {})[this.config.navCode || '~NA~'] || {}).childKeys || [])[0]){
						activateEntityKey = mainEntity.meta[this.config.navCode].childKeys[0]
					}
				}
				if(!activateEntityKey && defaultKey){
					activateEntityKey = defaultKey
				}
			}

			if(activateEntityKey){
				await this.navToEntity(activateEntityKey)
			}
		},
	},

	handlers: [
		{
			name: 'onTabActivate',
			componentClass: 'base_tabStrip_tab',
			handle(callerComponent){
				if(this.model.ignoreHandlers) return;
				const {entityKey} = callerComponent.getResourceRegisterContent('nav', false) || {}
				if(entityKey && !this.model.activeKeys[entityKey]){
					this.guiActivate(entityKey)
				}
			}
		},
		{
			name: 'onTabReActivate',
			componentClass: 'base_tabStrip_tab',
			handle(callerComponent){
				if(this.model.ignoreHandlers) return;
				const {entityKey} = callerComponent.getResourceRegisterContent('nav', false) || {}
				if(entityKey && !this.model.activeKeys[entityKey]){
					this.guiActivate(entityKey)
				}
			}
		},
		{
			name: 'onTabDeactivate',
			componentClass: 'base_tabStrip_tab',
			handle(callerComponent){
				if(this.model.ignoreHandlers) return;
				const {entityKey} = callerComponent.getResourceRegisterContent('nav', false) || {}
				if(entityKey && this.model.activeKeys[entityKey]){
					this.guiDeactivate(entityKey)
				}
			}
		},
		{
			name: 'onTabRemove',
			componentClass: 'base_tabStrip_tab',
			handle(callerComponent){
				if(this.model.ignoreHandlers) return;
				const {entityKey} = callerComponent.getResourceRegisterContent('nav', false) || {}
				if(entityKey && this.model.activeKeys[entityKey]){
					const activeTabStripKeys = this.getActiveTabStripKeys()
					if(!activeTabStripKeys.tabFound || !activeTabStripKeys.tabKey){
						this.guiDeactivate(entityKey)
					}
				}
			}
		},
	],
}